const genders = [
    { value: 'M', name: 'Male'},
    { value: 'F', name: 'Female'},
    { value: 'O', name: 'Other'},
  ];
  export default genders;